import { useEffect, useState } from "react";
import Angles from "../CameraAngles/CameraAngles";
import Header from "../Header";
import Player from "../Player/Player";
import TeethModel from "../Teeth/TeethModel";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import IPR from "../IPR/IPR";
import CustomProgress from "Components/CustomProgressBar/CustomProgress";

import {
  setAttachmentDetails,
  setIprDetails,
  setLowerAlignerFiles,
  setLowerModelIndex,
  setNoOfLowererAligners,
  setNoOfUpperAligners,
  setPatientDetails,
  setUpperAlignerFiles,
  setUpperModelIndex,
  toggleIpr,
} from "../../redux/modelSlice";
import { companyType } from "colors-config";

const ViewPort = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const dispatch = useDispatch();
  const { showIpr, iprDetails, progress} = useSelector((state) => state.model);
  const [showIprTable, setShowIprTable] = useState(false)
  const [targetPosition, setTargetPosition] = useState(null);
  const [reset, setReset] = useState(false);
  const isMobileDevice = /iPhone|iPod|Android/i.test(navigator.userAgent);

  const widgetParam = searchParams.get("isWidget");
  // console.log('showIpr mobile appppppp', widgetParam)
  useEffect(() => {
    fetchFiles();
  }, []);

  const fetchFiles = async () => {
    
    const searchParams = new URLSearchParams(window.location.search);
    const link_id = searchParams.get("link_id");
    const isDraft = searchParams.get("isDraft");
    const treatmentId = searchParams.get("treatmentId");
    const showIpr = searchParams.get("showIpr");
    if(showIpr === 'false' || showIpr === false){
        dispatch(toggleIpr());
    }
    if (link_id) {
      const res = await axios.get(
        `${process.env.REACT_APP_TPVIEWER_BACKEND_URL}/api/tpviewerTreatment/viewTPViewerDetails/${link_id}${treatmentId ? `/${treatmentId}`:""}${
          isDraft ? `?isDraft=true` : ""
        }`
      );
      //  const res = await axios.get(`https://smilelign-tp-backend-prod.smilegeniusapp.com/api/tpviewerTreatment/viewTPViewerDetails/737b5ef4-f2a2-4390-8a66-eb7f1573c5a3/TPSETUP24462503`);
  //  const res = await axios.get(`https://smilelign-tpviewer-dev.smilegeniusapp.com/api/tpviewerTreatment/viewTPViewerDetails/1489f6a4-c2af-40e6-aa41-758c37d3e183/TPSETUP25978953`);
    //  const res = await axios.get(` https://smilelign-tpviewer-dev.smilegeniusapp.com/api/tpviewerTreatment/viewTPViewerDetails/7e1bb28a-7d1e-4315-936d-8b87b09cd1fd/TPSETUP34797435`);
  //All attachs Teeths
      // const res = await axios.get(`https://tpviewer-uat.smilegeniusapp.com/api/tpviewerTreatment/viewTPViewerDetails/02a6f8dd-29bf-4869-94bb-f7650ebe5987/TPSETUP39078014`)
   //All Iprs and Attachments
      // const res = await axios.get(`https://smilelign-tpviewer-frontend-dev.smilegeniusapp.com/?link_id=ec0ab18a-7a77-47d2-906a-36a32cd3757c&treatmentId=TPSETUP90489519`)
    //Pressure Point
    // const res = await axios.get(`https://smilelign-tpviewer-dev.smilegeniusapp.com/api/tpviewerTreatment/viewTPViewerDetails/a38659ff-62a6-4eb8-8e03-d9562868890a/TPSETUP22111719`)

    //  const res = await axios.get(`https://smilelign-tpviewer-dev.smilegeniusapp.com/api/tpviewerTreatment/viewTPViewerDetails/a38659ff-62a6-4eb8-8e03-d9562868890a/TPSETUP22111719`)
    //Detail attach
    //  const res = await axios.get(`https://smilelign-tpviewer-dev.smilegeniusapp.com/api/tpviewerTreatment/viewTPViewerDetails/0093a9c9-e86f-43c3-a885-c2093798a2dd/TPSETUP7465005`)
    // const res = await axios.get(`https://smilelign-tpviewer-dev.smilegeniusapp.com/api/tpviewerTreatment/viewTPViewerDetails/368727bf-2cad-455d-abe3-c4a067345212/TPSETUP12909541`)
      // console.log("resssss", res)
      const response = res.data.data;
      const isMobile = /iPhone|iPad/i.test(navigator.userAgent);
      const sortedLowerFiles = response.lowerAlignerFiles
        .sort((a, b) => a.alignerCount - b.alignerCount)
        .map((file) => ((isMobile && file.mobileUrl) ? file.mobileUrl : file.url));
      const sortedUpperFiles = response.upperAlignerFiles
        .sort((a, b) => a.alignerCount - b.alignerCount)
        .map((file) => ((isMobile && file.mobileUrl) ? file.mobileUrl : file.url));
      dispatch(setPatientDetails(response.patientDetails));
      dispatch(setIprDetails(response.iprDetails));
      dispatch(setAttachmentDetails(response.attachmentDetails));
      dispatch(setLowerAlignerFiles(sortedLowerFiles));
      dispatch(setUpperAlignerFiles(sortedUpperFiles));
      dispatch(setNoOfLowererAligners(response.lowerAligners));
      dispatch(setNoOfUpperAligners(response.upperAligners));
      const zeroStage = (sortedLowerFiles.length + sortedUpperFiles.length) > (response.lowerAligners + response.upperAligners) ? 0 : 1;
      dispatch(setUpperModelIndex(zeroStage));
      dispatch(setLowerModelIndex(zeroStage));
    }
  };
  // const drAppCheck = widgetParam === 'true' || widgetParam === true
  let drAppCheck = true;
  if(companyType === 5){
    drAppCheck = widgetParam === 'true' || widgetParam === true
  } else {
    drAppCheck = isMobileDevice ? true : false;
  }
  // console.log("drAppCheckdrAppCheck", drAppCheck)
  
  
  return (
    <div className={drAppCheck ? "dr-app-container":"normal-app"}> 
      {progress !== 100 ? (
        <div>
          <CustomProgress percent={progress} />
        </div>
      ) : null}
      {progress === 100 && (
        <Header setReset={setReset} setTargetPosition={setTargetPosition} />
      )}
      <div
        className={
          showIpr ? `grid-column ${showIprTable ? "grid-column-index" : ""}`
            : "grid"
        }
        // style={{ display: "grid", gridTemplateColumns: (showIpr && iprDetails?.length > 0) ? "60% 40%" : "100%" }}
      >
        <TeethModel
          targetPosition={targetPosition}
          reset={reset}
          setReset={setReset}
        />
        <IPR showIprTable={showIprTable} setShowIprTable={setShowIprTable} />
      </div>
      {progress === 100 && (
        <Angles setReset={setReset} setTargetPosition={setTargetPosition} />
      )}
      {progress === 100 && <Player />}
    </div>
  );
};

export default ViewPort;
